var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "score-page" }, [
    _c("header", { staticClass: "sc-hero" }, [
      _c("div", { staticClass: "hero-top" }, [
        _c("span", { staticClass: "hero-back", on: { click: _vm.goBack } }, [
          _vm._v("‹"),
        ]),
        _c("span", { staticClass: "hero-title" }, [_vm._v("成绩曲线")]),
        _c("span", { staticClass: "hero-back ghost" }),
      ]),
      _vm.latest
        ? _c("div", { staticClass: "hero-card" }, [
            _c("div", { staticClass: "hc-head" }, [
              _c("span", { staticClass: "hc-name" }, [
                _vm._v(_vm._s(_vm.latest.name)),
              ]),
              _c("span", { staticClass: "hc-date" }, [
                _vm._v(_vm._s(_vm.latest.date)),
              ]),
            ]),
            _c("div", { staticClass: "hc-score" }, [
              _c("em", [_vm._v(_vm._s(_vm.latest.score))]),
              _c("span", { staticClass: "hc-full" }, [
                _vm._v("/ " + _vm._s(_vm.latest.full)),
              ]),
              _c(
                "span",
                {
                  staticClass: "hc-delta",
                  class: _vm.latest.delta >= 0 ? "up" : "down",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.latest.delta >= 0 ? "↑" : "↓") +
                      _vm._s(Math.abs(_vm.latest.delta)) +
                      " 分 "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "hc-foot" }, [
              _c("span", [
                _vm._v(
                  "班级排名 " +
                    _vm._s(_vm.latest.rank) +
                    " / " +
                    _vm._s(_vm.latest.classSize)
                ),
              ]),
              _c("span", [
                _vm._v(" 名次 "),
                _c("b", { class: _vm.latest.rankDelta >= 0 ? "up" : "down" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.latest.rankDelta >= 0 ? "↑" : "↓") +
                      _vm._s(Math.abs(_vm.latest.rankDelta)) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
    _c("main", { staticClass: "sc-body" }, [
      _c(
        "div",
        { staticClass: "chips" },
        _vm._l(_vm.series, function (s) {
          return _c(
            "span",
            {
              key: s.key,
              staticClass: "chip",
              class: { on: s.key === _vm.currentKey },
              on: {
                click: function ($event) {
                  _vm.currentKey = s.key
                },
              },
            },
            [_vm._v(" " + _vm._s(s.name) + " ")]
          )
        }),
        0
      ),
      _vm.chart
        ? _c("section", { staticClass: "chart-card" }, [
            _c("div", { staticClass: "chart-head" }, [
              _c("span", { staticClass: "chart-title" }, [
                _vm._v(_vm._s(_vm.current.name) + " 走势"),
              ]),
              _c("span", { staticClass: "chart-sub" }, [
                _vm._v(
                  _vm._s(_vm.exams.length) +
                    " 次考试 · 满分 " +
                    _vm._s(_vm.current.full)
                ),
              ]),
            ]),
            _c("div", { staticClass: "chart-wrap" }, [
              _c(
                "svg",
                {
                  staticClass: "chart",
                  attrs: {
                    viewBox: "0 0 " + _vm.chart.W + " " + _vm.chart.H,
                    preserveAspectRatio: "xMidYMid meet",
                  },
                },
                [
                  _c(
                    "defs",
                    [
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "scoreArea",
                            x1: "0",
                            y1: "0",
                            x2: "0",
                            y2: "1",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#378add",
                              "stop-opacity": "0.26",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#378add",
                              "stop-opacity": "0",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.chart.ticks, function (t, i) {
                    return _c("g", { key: "t" + i }, [
                      _c("line", {
                        attrs: {
                          x1: _vm.chart.padL,
                          x2: _vm.chart.W - _vm.chart.padR,
                          y1: t.y,
                          y2: t.y,
                          stroke: "#eef1f6",
                          "stroke-width": "1",
                        },
                      }),
                      _c(
                        "text",
                        {
                          attrs: {
                            x: _vm.chart.padL - 12,
                            y: t.y + 7,
                            "text-anchor": "end",
                            "font-size": "20",
                            fill: "#a3abba",
                          },
                        },
                        [_vm._v(" " + _vm._s(t.v) + " ")]
                      ),
                    ])
                  }),
                  _c("path", {
                    attrs: { d: _vm.chart.area, fill: "url(#scoreArea)" },
                  }),
                  _c("polyline", {
                    attrs: {
                      points: _vm.chart.line,
                      fill: "none",
                      stroke: "#378add",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._l(_vm.chart.pts, function (p, i) {
                    return _c("g", { key: "p" + i }, [
                      _c("circle", {
                        attrs: {
                          cx: p.x,
                          cy: p.y,
                          r: i === _vm.chart.pts.length - 1 ? 9 : 6,
                          fill:
                            i === _vm.chart.pts.length - 1 ? "#378add" : "#fff",
                          stroke: "#378add",
                          "stroke-width": "3",
                        },
                      }),
                      _c(
                        "text",
                        {
                          attrs: {
                            x: p.x,
                            y: p.y - 22,
                            "text-anchor": "middle",
                            "font-size": "24",
                            "font-weight": "600",
                            fill:
                              i === _vm.chart.pts.length - 1
                                ? "#185fa5"
                                : "#5f6b7d",
                          },
                        },
                        [_vm._v(" " + _vm._s(p.v) + " ")]
                      ),
                    ])
                  }),
                  _vm._l(_vm.chart.pts, function (p, i) {
                    return _c("g", { key: "x" + i }, [
                      _c(
                        "text",
                        {
                          attrs: {
                            x: p.x,
                            y: _vm.chart.baseY + 36,
                            "text-anchor": "middle",
                            "font-size": "22",
                            fill: "#8a94a6",
                          },
                        },
                        [_vm._v(" " + _vm._s(p.name) + " ")]
                      ),
                      _c(
                        "text",
                        {
                          attrs: {
                            x: p.x,
                            y: _vm.chart.baseY + 62,
                            "text-anchor": "middle",
                            "font-size": "20",
                            fill: "#c2c9d6",
                          },
                        },
                        [_vm._v(" " + _vm._s(p.date) + " ")]
                      ),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "chart-foot" }, [
              _c("div", { staticClass: "cf-item" }, [
                _c("p", { staticClass: "cf-label" }, [_vm._v("最高")]),
                _c("p", { staticClass: "cf-num" }, [
                  _vm._v(_vm._s(_vm.chart.max)),
                ]),
              ]),
              _c("div", { staticClass: "cf-item" }, [
                _c("p", { staticClass: "cf-label" }, [_vm._v("最低")]),
                _c("p", { staticClass: "cf-num" }, [
                  _vm._v(_vm._s(_vm.chart.min)),
                ]),
              ]),
              _c("div", { staticClass: "cf-item" }, [
                _c("p", { staticClass: "cf-label" }, [_vm._v("平均")]),
                _c("p", { staticClass: "cf-num" }, [
                  _vm._v(_vm._s(_vm.currentAvg)),
                ]),
              ]),
              _c("div", { staticClass: "cf-item" }, [
                _c("p", { staticClass: "cf-label" }, [_vm._v("最近排名")]),
                _c("p", { staticClass: "cf-num" }, [
                  _vm._v(
                    _vm._s(_vm.current.rank) +
                      "/" +
                      _vm._s(_vm.current.classSize)
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("section", { staticClass: "block" }, [
        _c("div", { staticClass: "block-head" }, [
          _c("span", { staticClass: "block-title" }, [
            _vm._v(_vm._s(_vm.current.name) + " · 历次明细"),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "rows" },
          _vm._l(_vm.rows, function (r) {
            return _c("div", { key: r.key, staticClass: "row" }, [
              _c("div", { staticClass: "row-main" }, [
                _c("p", { staticClass: "row-name" }, [_vm._v(_vm._s(r.name))]),
                _c("p", { staticClass: "row-date" }, [_vm._v(_vm._s(r.date))]),
              ]),
              _c("div", { staticClass: "row-score" }, [
                _c("em", [_vm._v(_vm._s(r.score))]),
                _c("span", { staticClass: "row-full" }, [
                  _vm._v("/ " + _vm._s(_vm.current.full)),
                ]),
              ]),
              _c("div", { staticClass: "row-rank" }, [
                _c("p", { staticClass: "rr-num" }, [
                  _vm._v("第 " + _vm._s(r.rank) + " 名"),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "rr-delta",
                    class:
                      r.rankDelta > 0 ? "up" : r.rankDelta < 0 ? "down" : "",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          r.rankDelta > 0
                            ? "↑" + r.rankDelta + " 名"
                            : r.rankDelta < 0
                            ? "↓" + Math.abs(r.rankDelta) + " 名"
                            : "持平"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
            ])
          }),
          0
        ),
        _c("p", { staticClass: "tip" }, [
          _vm._v("演示数据 · 接入成绩表后按同样的结构返回即可"),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }